// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {message} from './utils/resetMessage' 
import api from './http'
import { HttpService } from './http/HttpService';
import { mystorage } from './utils/myStorage'
import ElementUI from 'element-ui'
import global_ from '@/utils/global.vue'//全局常量
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

//全部导入
import _ from 'lodash'

import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
import '@/assets/element-variables.scss'

import * as echarts from 'echarts';

import 'echarts'
import ECharts from 'vue-echarts'
import "regenerator-runtime/runtime.js"; // 异步加载
import VueWechatTitle from 'vue-wechat-title'; //显示title
import infiniteScroll from 'vue-infinite-scroll'
import VueContextMenu from 'vue-contextmenu'
import Print from 'vue-print-nb'
import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs;

Vue.use(Print)
Vue.use(infiniteScroll)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(UmyUi);
Vue.use(VueWechatTitle)
Vue.use(api)
Vue.use(preview)
Vue.prototype._ = _  //全部导入的挂载方式
Vue.prototype.global = global_
Vue.prototype.$echarts = echarts;
Vue.prototype.$http=HttpService
Vue.prototype.mystorage = mystorage
Vue.prototype.$message=message  // 重写message 提示框
Vue.use(VueContextMenu)
Vue.component('VueEcharts', ECharts)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js